import { useForm, useWatch } from 'react-hook-form'
import * as yup from 'yup'
import { useIntl } from 'react-intl'
import { yupResolver } from '@hookform/resolvers/yup'
// import { useRouter } from 'next/router'

const usePersonalDataForm = () => {
  // const router = useRouter()
  const { formatMessage: f } = useIntl()
  const {
    control, setValue, onSubmit: handleSubmit, formState, getValues,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        contactName: yup.string()
          .required(f({ id: 'APPRAISAL_PLEASE_ENTER_NAME' }))
          .matches(/([a-zA-Z])+([ a-zA-ZÀ-ÖØ-öø-ÿ])+$/, f({ id: 'APPRAISAL_PLEASE_ENTER_NAME_LETTERS' })),
        phone: yup
          .string()
          .required(f({ id: 'APPRAISAL_PLEASE_ENTER_PHONE' }))
          .min(10, f({ id: 'APPRAISAL_PLEASE_ENTER_10_DIGITS_PHONE' }))
          .max(10, f({ id: 'APPRAISAL_PLEASE_ENTER_10_DIGITS_PHONE' })),
        email: yup
          .string()
          .email(f({ id: 'APPRAISAL_PLEASE_ENTER_VALID_EMAIL' }))
          // eslint-disable-next-line no-useless-escape
          .required(f({ id: 'APPRAISAL_PLEASE_ENTER_EMAIL' })).matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, f({ id: 'APPRAISAL_PLEASE_ENTER_VALID_EMAIL' })),
        name: yup.string().required(),
        postalCode: yup.string()
          .required(f({ id: 'APPRAISAL_PLEASE_ENTER_ZIPCODE' }))
          .min(5, f({ id: 'APPRAISAL_PLEASE_ENTER_5_DIGITS_PHONE' }))
          .max(5, f({ id: 'APPRAISAL_PLEASE_ENTER_5_DIGITS_PHONE' })),
      }),
    ),
    defaultValues: {
      contactName: '',
      phone: '',
      email: '',
      name: '',
      postalCode: '',
    },
    mode: 'all',
  })
  const [
    contactName,
    phone,
    email,
    name,
    postalCode,
  ] = useWatch({
    control,
    name: [
      'contactName',
      'phone',
      'email',
      'name',
      'postalCode',
    ],
  })

  return {
    setValue,
    getValues,
    onSubmit: handleSubmit,
    formState,
    control,
    contactName,
    phone,
    email,
    name,
    postalCode,
  }
}

export default usePersonalDataForm
